import React, { useState } from "react";
import s from "./style.module.scss";
import Coins from "shared/ui/Bonuses/icons/Coins";
import { renderWord } from "../lib/renderWord";
import Button from "shared/ui/Button";
import { ActivateGiftApi } from "../api";
import { useAppDispatch, useAppSelector } from "shared/redux/hooks";
import { userSelect } from "shared/redux/selectors/user";
import { showError } from "shared/lib/showError";
import { setContent, setOpen } from "shared/redux/reducers/PopupSlice";

interface ActivateProps {
  price: number;
  onSuccess: (id: number, activated: boolean) => void;
  text: string;
  id: number;
}

const Activate: React.FC<ActivateProps> = ({ price, onSuccess, text, id }) => {
  const dispatch = useAppDispatch();
  const { user_info } = useAppSelector(userSelect);
  const [code, setCode] = useState("");

  const [dataSending, setDataSending] = useState(false);

  const handleSubmit = () => {
    if (id && user_info) {
      setDataSending(true);

      ActivateGiftApi({
        bonus_id: id,
        code,
        msisdn: user_info.msisdn,
        user_id: user_info.id,
      })
        .then((res) => {
          onSuccess(res.id, true);
        })
        .catch((e) => showError(e, dispatch))
        .finally(() => setDataSending(false));
    }
  };

  const handleCancel = () => {
    dispatch(setOpen(false));
    dispatch(setContent(null));
  };

  return (
    <div className={s.activate}>
      <h5>С вашего бонусного счета списано</h5>

      <div className={s.bonuses}>
        <Coins /> {price} {renderWord(price)}
      </div>

      <p>{text}</p>

      <input
        className={s.input}
        value={code}
        onChange={(e) => setCode(e.target.value)}
        type="text"
      />

      <Button
        disabled={dataSending}
        className={s.accept}
        onClick={handleSubmit}
      >
        Готово
      </Button>
      <button onClick={handleCancel} className={s.cancel}>
        Позже
      </button>
    </div>
  );
};

export default Activate;
